
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { createLogger } from "@/services/utils/loggingUtils";

const logger = createLogger("DeleteRequestService");

// Delete a reagent request (soft delete)
export const deleteReagentRequest = async (id: string): Promise<boolean> => {
  try {
    const { error } = await supabase
      .from("reagent_requests")
      .update({ is_deleted: true, updated_at: new Date().toISOString() })
      .eq("id", id);

    if (error) {
      logger.error("Error deleting reagent request:", error);
      toast.error("Failed to delete reagent request: " + error.message);
      return false;
    }

    toast.success("Reagent request deleted successfully!");
    return true;
  } catch (error) {
    logger.error("Exception in deleteReagentRequest:", error);
    return false;
  }
};
